import type { NetworkCaip, SupportedCaip } from '../types'
import { getNetworkFromChainId } from './getNetworkFromChainId'

type ExtractIdFromCaip<T extends NetworkCaip> = T extends `eip155:${infer T extends number}` ? T : never

export function getNetworkFromCaip<T extends SupportedCaip>(caip: T) {
  const network = getNetworkFromChainId(Number(caip.split(':')[1]) as ExtractIdFromCaip<T>)
  if (!network) throw new Error(`Unsupported chainId: ${Number(caip.split(':')[1])}`)
  return network
}
